import { z } from 'zod';

// Define the search params schema
export const invitePageSchema = z.object({
  action: z.string().default(''),
  email: z.string().default(''),
  id: z.coerce.string().default(''), // This will coerce numbers to strings
  type: z.string().default(''),
});

export const setPasswordSchema = z
  .object({
    // TODO:UX-2865 Check with platform for password requirements.
    password: z
      .string()
      .min(8, { message: 'Password must be at least 8 characters long' })
      .regex(/[a-z]/, { message: 'Password must contain at least one lowercase letter' })
      .regex(/[A-Z]/, { message: 'Password must contain at least one uppercase letter' })
      .regex(/[0-9]/, { message: 'Password must contain at least one number' }),
    confirmPassword: z.string(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'Passwords must match',
    path: ['confirmPassword'],
  });
